import SchemaMarkup from "../Components/SchemaMarkup";

const MedicalTherapySchema = ({ treatment }) => {
  if (!treatment) return null;

  const url = `https://msayurved.com/treatments/${treatment.slug}/`;

  const schema = {
    "@context": "https://schema.org",
    "@type": "MedicalTherapy",
    "@id": `${url}#treatment`,
    "name": treatment.introHeading,
    "description": treatment.introDesc,
    "url": url,
    "medicineSystem": {
      "@type": "MedicineSystem",
      "name": "Ayurvedic Medicine"
    },
    "provider": {
      "@id": "https://msayurved.com/#medicalclinic"
    }
  };

  return <SchemaMarkup data={schema} />;
};

export default MedicalTherapySchema;